export default {
    news: [],
}
